// extracted by mini-css-extract-plugin
export var badge = "_hu-2";
export var detailsPanel = "_hu-0";
export var resultRow = "_hu-1";